import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { LinkedService } from './linkedservice';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: ModelConstants.microsoftTeamsLinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.MicrosoftTeamsIdLabel),
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.MicrosoftTeamsIdLabel)
    ]
})
export class MicrosoftTeamsLinkedService extends LinkedService { }
